'use strict';

angular.module('licensure.portal')
    .directive('portalFooter', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'components/footer/footer.html',
            controller: ['$scope', '$rootScope', '$sce', 'CMSSites', 'CMSPages', 'Format', function ($scope, $rootScope, $sce, CMSSites, CMSPages, Format) {

                $scope.editing = false;

                if ($rootScope.site) {
                    $scope.site = $rootScope.site;
                }
                
                if (!$scope.site) {
                    $scope.site = {};
                }

                if (!$scope.site.public_portal_footer) {
                    $scope.site.public_portal_footer = "";
                }

                $rootScope.$watch('loadingSite', function (newValue, oldValue) {
                    if (!newValue) {
                        $scope.site = $rootScope.site;
                    }
                });

                $scope.renderHtml = function (htmlCode) {
                    if (typeof htmlCode == "string") {
                        return $sce.trustAsHtml(htmlCode);
                    }
                    return "";
                }

                $scope.edit = function () {
                    var isInIframe = (parent !== window);
                    if (isInIframe) {
                        if (window.parent.location.href.includes($rootScope.enterprise.site_location + "license/admin/public_portal/layout.cfm")){
                            $scope.editing = true;
                        }
                    }
                }

                $scope.close = function () {
                    $scope.editing = false;
                }

                $scope.saveFooter = function () {
                    $scope.footerSaving = true;
                    CMSSites.save($scope.site).then(function (result) {
                        $scope.footerSaving = false;
                        $scope.editing = false;
                    });
                }
            }],
            replace: true,
            link: function (scope, elem, attrs, ctrl) {

            }
        };
    }])
;